import React from 'react';
interface CTAButtonProps {
  text?: string;
  className?: string;
}
export const CHECKOUT_URL = 'https://pagos.resolia.shop/cart/49390155989229:1';
export function CTAButton({
  text = '👉 SÍ, QUIERO ACCEDER AL MEGA PACK',
  className = ''
}: CTAButtonProps) {
  return <a href={CHECKOUT_URL} className={`block w-full max-w-md mx-auto bg-[#22c55e] hover:bg-[#1ea34d] text-white text-xl md:text-2xl font-black py-4 px-6 rounded-full text-center uppercase tracking-wide shadow-[0_0_20px_rgba(34,197,94,0.5)] transition-all transform hover:scale-105 animate-[pulse_2s_infinite] ${className}`} data-id="element-329">
      {text}
    </a>;
}